import { render } from "./PerfilView.vue?vue&type=template&id=5528bb01&scoped=true"
import script from "./PerfilView.vue?vue&type=script&lang=js"
export * from "./PerfilView.vue?vue&type=script&lang=js"

import "./PerfilView.vue?vue&type=style&index=0&id=5528bb01&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5528bb01"]])

export default __exports__